module.exports = __webpack_public_path__ + "static/media/abc-news-au.ace9d839.jpg";